import { SUPPLY_TARGETING_TYPES } from 'modules/campaigns/modules/common-campaign-form/components/SupplyTargeting/const.js';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { useSupplyTargetingFormField } from './useSupplyTargetingFormField';

export const useSupplyGroup = () => {
    const { value: supplyGroup } = useSupplyTargetingFormField();
    const { value: taboolaSelect } = useFormFieldValue({
        field: 'campaignTargeting.taboolaSelect',
    });
    return taboolaSelect === true ? SUPPLY_TARGETING_TYPES.TABOOLA_SELECT : supplyGroup;
};
